module.exports = __webpack_public_path__ + "img/reward_reach_02.e60bb669.png";